













































































































import { computed, defineComponent, useStore } from '@nuxtjs/composition-api'
import { FooterInfo } from '@/contracts/Settings'
import ContactBlock from '@/components/ContactBlock'
import BlockText from '@/components/BlockText'
import Link from '@/components/Link'
import FooterLinksColumn from '@/components/Footer/new-design/FooterLinksColumn'
import NewButton from '@/components/Inputs/new-design/NewButton'
import CityFromCookie from '@/components/CityFromCookie'
import BlockFooterBanner from '@/components/Footer/new-design/BlockFooterBanner'

export default defineComponent({
  name: 'FooterNew',
  components: {
    BlockFooterBanner,
    CityFromCookie,
    FooterLinksColumn,
    ContactBlock,
    Link,
    BlockText,
    NewButton,
  },
  setup() {
    const store = useStore()
    const footerInfo = computed(
      () => store.getters['settings/footerInfo'] as FooterInfo
    )
    const cookie = computed(() => store.getters['settings/cookie'])
    const updatedTime = computed(() => store.getters['settings/getUpdatedTime'])

    const showCityPopup = () => store.commit('popupCityList/SET_SHOWN', true)
    const formatDate = (isoDate: string): string => {
      if (!isoDate) return ''
      const date = new Date(isoDate)
      const day = ('0' + date.getDate()).slice(-2)
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const year = date.getFullYear()
      return `${day}.${month}.${year}`
    }
    const formattedUpdatedTime = computed(() => formatDate(updatedTime.value))
    return {
      footerInfo,
      cookie,
      formattedUpdatedTime,
      showCityPopup,
    }
  },
})
